const menu = () => {
  const header = document.getElementById('js-header'),
    megaMenu = document.getElementById('js-mega-menu'),
    openMegaMenuBtns = document.getElementById('js-menu'),
    closeMegaMenuBtns = document.querySelectorAll('.js-close-mega-menu-btn'),
    html = document.getElementsByTagName('html')[0]

  openMegaMenuBtns &&
    openMegaMenuBtns.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-open-mega-menu-btn')) {
        e.preventDefault()

        if (e.target.classList.contains('js-selected')) {
          changeModalState(e.target, true)
        } else {
          changeModalState(e.target, false)
        }
      }
    })

  closeMegaMenuBtns &&
    closeMegaMenuBtns.forEach((closeMegaMenuBtn) => {
      closeMegaMenuBtn.addEventListener('click', (e) => {
        changeModalState(closeMegaMenuBtn, true)
      })
    })

  const changePanelState = (btn, state) => {
    const id = btn.dataset.menuId

    openMegaMenuBtns.querySelectorAll('button').forEach((elm) => {
      if (state === false && id === elm.dataset.menuId) {
        elm.classList.add('js-selected')
        elm.ariaSelected = true
      } else {
        elm.classList.remove('js-selected')
        elm.ariaSelected = false
      }
    })

    megaMenu.querySelectorAll('nav').forEach((elm) => {
      if (state === false && id === elm.dataset.id) {
        elm.classList.add('js-active')
        elm.classList.remove('js-inactive')
        elm.ariaHidden = false
      } else {
        elm.classList.remove('js-active')
        elm.classList.add('js-inactive')
        elm.ariaHidden = true
      }
    })
  }

  const changeModalState = (btn, state) => {
    changePanelState(btn, state)

    megaMenu.ariaHidden = state

    if (state === false && header.classList.contains('mega-menu-active')) return

    html.classList.toggle('js-noscroll')
    header.classList.toggle('mega-menu-active')
    megaMenu.classList.toggle('js-active')
    megaMenu.classList.toggle('js-inactive')
  }
}

export default menu
